"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToPullquoteProps({ data }) {
    return {
        children: data?.quote,
        cite: data?.attribution,
    };
}
exports.default = mapToPullquoteProps;
